export default "__VITE_ASSET__0e9b2c13__"